export default __webpack_public_path__ + "static/media/YAY.e26dba37.png";